// projects/my-lib/src/lib/provide-my-lib.ts
import { Provider } from '@angular/core';
import { TASLibConfig } from './config/tas-lib.config';
import { TAS_LIB_CONFIG } from './config/tas-lib.token';
import { SearchService } from './services/search.service';

export function provideTasLib(config: TASLibConfig): Provider[] {
  return [
    { provide: TAS_LIB_CONFIG, useValue: config },
    SearchService
  ];
}
